import React from 'react';

const SearchResultcontainer = ({ children }) => {
  return (
    <div className="searchResultsContainer">
      {children}
    </div>
  );
};

export default SearchResultcontainer;